import { render, staticRenderFns } from "./couresTab.vue?vue&type=template&id=2d8d81be&scoped=true"
import script from "./couresTab.vue?vue&type=script&lang=js"
export * from "./couresTab.vue?vue&type=script&lang=js"
import style0 from "./couresTab.vue?vue&type=style&index=0&id=2d8d81be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d81be",
  null
  
)

export default component.exports